import axios from "axios";

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

const persistedToken =
  typeof window !== "undefined"
    ? window.localStorage.getItem("access_token")
    : null;

if (persistedToken) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${persistedToken}`;
}

// Determine API URL - use relative paths for dev (proxy via Vite), absolute for production
let apiUrl = "/api";

if (typeof window !== "undefined") {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  // In development (accessed via local network IP like 192.168.1.100):
  // - Vite dev server proxies /api to http://localhost:3000
  // - Always use relative /api paths to work through the proxy
  //
  // In production (backend served on same domain):
  // - Use relative /api paths (backend serves API at same domain)
  //
  // Development with direct backend access (localhost only):
  // - Vite proxy handles it automatically with relative /api

  // Always prefer relative paths - let the server/proxy handle routing
  if (isLocalhost) {
    apiUrl = "/api";
    console.log("📍 Localhost detected, using relative path (Vite proxy)");
  } else if (hostname.includes("192.168.")) {
    // Local network access - still use relative path through Vite proxy
    apiUrl = "/api";
    console.log("🌐 Local network detected, using relative path (Vite proxy)");
  } else if (hostname.includes(".local")) {
    // .local domain - use relative path
    apiUrl = "/api";
    console.log("🌐 .local domain detected, using relative path");
  }
}

axios.defaults.baseURL = apiUrl;

export default axios;
